var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryNormal = function SvgCategoryNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 45"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-8h60v60H-4z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5 43.5v1H.5v-1zm-36-20v1H.5v-1zm0-20v1H.5v-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    x: 19,
    y: 1,
    strokeWidth: 2,
    rx: 14
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "m50 32-8-8"
  })))));
};
export default SvgCategoryNormal;